import { Routes } from "@angular/router";
const titleFunction = (pageTitle: string): string => {
  return "Hala - " + pageTitle;
};

export const routes: Routes = [
  {
    path: "",
    redirectTo: "sign-up/business-type",
    pathMatch: "full",
  },
  {
    path: "sign-up",
    loadComponent: () =>
      import("./layouts/two-column-layout/two-column-layout.component").then(
        (m) => m.TwoColumnLayoutComponent
      ),
    children: [
      {
        path: "business-type",
        loadComponent: () =>
          import("./pages/signup/business-type/business-type.component").then(
            (m) => m.BusinessTypeComponent
          ),
      },
      {
        path: "mobile-verification",
        loadComponent: () =>
          import(
            "./pages/signup/mobile-verification/mobile-verification.component"
          ).then((m) => m.MobileVerificationComponent),
      },
      {
        path: "register-corporation",
        loadComponent: () =>
          import("./pages/corporation/corporation.component").then(
            (m) => m.CorporationComponent
          ),
      },
    ],
  },
  {
    path: "registration",
    loadComponent: () =>
      import("./layouts/stepper-layout/stepper-layout.component").then(
        (m) => m.StepperLayoutComponent
      ),
    title: titleFunction("Registration"),
    children: [
      {
        path: "business-info",
        loadComponent: () =>
          import(
            "./pages/registration/cr-information/cr-information.component"
          ).then((m) => m.CRInformationComponent),
      },
      {
        path: "review-business-information",
        loadComponent: () =>
          import(
            "./pages/registration/review-personal-info/review-personal-info.component"
          ).then((m) => m.ReviewPersonalInfoComponent),
      },
      {
        path: "nafath-verification",
        loadComponent: () =>
          import(
            "./pages/registration/nafath-verification/nafath-verification.component"
          ).then((m) => m.NafathVerificationComponent),
      },
      {
        path: "business-kyc",
        loadComponent: () =>
          import(
            "./pages/registration/business-details/business-details.component"
          ).then((m) => m.BusinessDetailsComponent),
      },
      {
        path: "tax-kyc",
        loadComponent: () =>
          import(
            "./pages/registration/business-tax-details/business-tax-details.component"
          ).then((m) => m.BusinessTaxDetailsComponent),
      },
      {
        path: "account-kyc",
        loadComponent: () =>
          import(
            "./pages/registration/account-information/account-information.component"
          ).then((m) => m.AccountInformationComponent),
      },
      {
        path: "national-address-setup",
        loadComponent: () =>
          import(
            "./pages/registration/national-address-setup/national-address-setup.component"
          ).then((m) => m.NationalAddressSetupComponent),
      },
      {
        path: "location-setup",
        loadComponent: () =>
          import(
            "./pages/registration/location-setup/location-setup.component"
          ).then((m) => m.LocationSetupComponent),
        children: [
          {
            path: "manage-locations",
            loadComponent: () =>
              import(
                "./pages/registration/location-setup/manage-locations/manage-locations.component"
              ).then((m) => m.ManageLocationsComponent),
          },
          {
            path: "location-information",
            loadComponent: () =>
              import(
                "./pages/registration/location-setup/locations-details/locations-details.component"
              ).then((m) => m.LocationDetailsComponent),
          },
          {
            path: "location-products",
            loadComponent: () =>
              import(
                "./pages/registration/location-setup/location-wise-products/location-wise-products.component"
              ).then((m) => m.LocationWiseProductsComponent),
          },
          {
            path: "location-users",
            loadComponent: () =>
              import(
                "./pages/registration/location-setup/add-user/add-user.component"
              ).then((m) => m.AddUserComponent),
          },
        ],
      },
      {
        path: "add-products",
        loadComponent: () =>
          import(
            "./pages/registration/add-products/add-products.component"
          ).then((m) => m.AddProductsComponent),
      },
      {
        path: "summary",
        loadComponent: () =>
          import("./pages/registration/summary/summary.component").then(
            (m) => m.SummaryComponent
          ),
      },
    ],
  },
  {
    path: "complete",
    loadComponent: () =>
      import("./pages/complete/complete.component").then(
        (m) => m.CompleteComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'sign-up/business-type'
  }

  // {
  //   path: 'components',
  //   loadComponent: () =>
  //     import(
  //       './pages/registration/registration-components/registration-components.component'
  //     ).then((m) => m.RegistrationComponentsComponent),
  //   title: titleFunction('Compoenents'),
  // },
];
